export enum NotificationType {
  ERROR = "error",
  SUCCESS = "success",
  INFO = "info",
}
